document.addEventListener("DOMContentLoaded", function() {
  // constantes
  const anchor = document.querySelector('a[href*="."]');
  const sr = ScrollReveal();
  const productArticle = document.querySelector(".product__article");
  const shopArticle = document.querySelector(".shop__article");
  const purchaseDescription = document.querySelector(".purchase__description");
  const shoeImg = document.querySelector(".product__image");
  const shopImg = document.querySelector(".shop__image");
  const form = document.querySelector(".contact__form");

  // Smooth scrolling
  anchor.addEventListener("click", function(e) {
    e.preventDefault();
    const target = anchor.getAttribute("href");
    let targetOffset = document.querySelector("" + target).offsetTop;
    window.scrollTo({
      top: targetOffset,
      behavior: "smooth"
    });
  });

  // Apparition bouton haut de page
  const button = document.querySelector(".arrow__top");

  window.onscroll = function() {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 700 ||
      document.documentElement.scrollTop > 700
    ) {
      button.classList.add("arrow__top--show");
    } else {
      button.classList.remove("arrow__top--show");
    }
  }

  // Remplacer image principale de la galerie
  let imgs = document.querySelectorAll(".gallery__item img");

  for (let i = 0; i < imgs.length; i++) {
    let activeImage = document.querySelector(".purchase__image--active");
    let img = imgs[i];
    img.onclick = function() {
      let newSrc = this.getAttribute("src");
      let oldSrc = activeImage.getAttribute("src");
      activeImage.setAttribute("src", newSrc);
      img.setAttribute("src", oldSrc);
    };
  }

  // Date à atteindre à la fin du compteur
  let target_date = new Date("2020-04-30").getTime();
  // Variables pour les unités de temps
  let days, hours, minutes, seconds;
  // Countdown
  let countdown = document.querySelector(".purchase__timer");

  // Mise à jour toutes les secondes
  setInterval(function() {
    let current_date = new Date().getTime();
    let seconds_left = (target_date - current_date) / 1000;

    // Calculs
    days = parseInt(seconds_left / 86400);
    seconds_left = seconds_left % 86400;
    hours = parseInt(seconds_left / 3600);
    seconds_left = seconds_left % 3600;
    minutes = parseInt(seconds_left / 60);
    seconds = parseInt(seconds_left % 60);

    countdown.innerHTML =
      days + "j " + hours + "h " + minutes + "m " + seconds + "s ";
  }, 1000);

  // ScrollReveal
  sr.reveal(productArticle, {
    origin: "left",
    distance: "200px",
    delay: 600
  });
  sr.reveal(shoeImg, {
    delay: 600
  });
  sr.reveal(shopArticle, {
    origin: "right",
    distance: "200px",
    delay: 600
  });
  sr.reveal(shopImg, {
    delay: 600
  });
  sr.reveal(purchaseDescription, {
    origin: "right",
    distance: "200px",
    delay: 600
  });
  sr.reveal(form, {
    origin: "left",
    distance: "200px",
    delay: 600
  });
});
